import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={21}
    height={21}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#212121"
        d="M13.075 11.851h-.659l-.233-.225a5.392 5.392 0 0 0 1.309-3.525 5.417 5.417 0 1 0-5.417 5.417A5.393 5.393 0 0 0 11.6 12.21l.225.233v.658l4.167 4.159 1.241-1.242-4.158-4.167Zm-5 0a3.745 3.745 0 0 1-3.75-3.75 3.745 3.745 0 0 1 3.75-3.75 3.745 3.745 0 0 1 3.75 3.75 3.745 3.745 0 0 1-3.75 3.75Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.158.185h20v20h-20z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgComponent
